import Store from '@/store'

export default [
  {
    name: 'Dashboard',
    path: '/dashboard/:account',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/layouts/Dashboard.vue'),
    meta: { authUser: true },
    children: [

      // ========================
      // HOME
      // ========================

      {
        name: 'Overview',
        path: 'overview',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/overview/Overview.vue')
      },


      
      
      // ========================
      // ORDERS
      // ========================

      {
        name: 'OrderList',
        path: 'orders',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/orders/OrderList.vue')
      },
      {
        name: 'OrderCreate',
        path: 'orders/add',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/orders/OrderCreate.vue')
      },
      {
        name: 'OrderEdit',
        path: 'orders/:id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/orders/OrderEdit.vue')
      },

      {
        name: 'BookingList',
        path: 'bookings',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/bookings/BookingList.vue')
      },
      {
        name: 'BookingEdit',
        path: 'bookings/:id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/bookings/BookingEdit.vue')
      },
      {
        name: 'BookingOriginEdit',
        path: 'bookings/:id/origins/:origin_id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/bookings/BookingAddressEdit.vue')
      },
      {
        name: 'BookingDestinationEdit',
        path: 'bookings/:id/destinations/:destination_id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/bookings/BookingAddressEdit.vue')
      },

      {
        name: 'BatchUpload',
        path: 'batch',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/batch/BatchUpload.vue')
      },


      // ========================
      // CUSTOMERS
      // ========================
      
      {
        name: 'CustomerList',
        path: 'customers',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/customers/CustomerList.vue')
      },
      {
        name: 'CustomerView',
        path: 'customers/:id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/customers/CustomerView.vue')
      },
      {
        name: 'CustomerCreate',
        path: 'customers/add',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/customers/CustomerForm.vue')
      },
      {
        name: 'CustomerEdit',
        path: 'customers/:id/edit',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/customers/CustomerForm.vue')
      },
      
      {
        name: 'AddressList',
        path: 'addresses',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/addresses/AddressList.vue')
      },
      {
        name: 'AddressCreate',
        path: 'addresses/add',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/addresses/AddressForm.vue')
      },
      {
        name: 'AddressEdit',
        path: 'addresses/:id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/addresses/AddressForm.vue')
      },


      // ========================
      // NOTIFICATIONS
      // ========================
      
      {
        name: 'NotificationList',
        path: 'notifications',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/notifications/NotificationList.vue')
      },

      {
        name: 'NotificationSettings',
        path: 'notification-settings',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/notifications/NotificationSettings.vue')
      },
      

      // ========================
      // WEBSITE
      // ========================

      {
        name: 'BookingFormList',
        path: 'booking-forms',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/booking-forms/BookingFormList.vue')
      },
      {
        name: 'BookingFormCreate',
        path: 'booking-forms/add',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/booking-forms/BookingFormForm.vue')
      },
      {
        name: 'BookingFormEdit',
        path: 'booking-forms/:id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/booking-forms/BookingFormForm.vue')
      },

      {
        name: 'ProductList',
        path: 'products',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/products/ProductList.vue')
      },
      {
        name: 'ProductCreate',
        path: 'products/add',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/products/ProductForm.vue')
      },
      {
        name: 'ProductEdit',
        path: 'products/:id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/products/ProductForm.vue')
      },

      {
        name: 'AddonList',
        path: 'addons',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/addons/AddonList.vue')
      },
      {
        name: 'AddonCreate',
        path: 'addons/add',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/addons/AddonForm.vue')
      },
      {
        name: 'AddonEdit',
        path: 'addons/:id',
        meta: { product: 'orders' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/addons/AddonForm.vue')
      },


      // ========================
      // AUTOMATIONS
      // ========================

      {
        name: 'AutomationList',
        path: 'automations',
        meta: { product: 'automations' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/automations/AutomationList.vue')
      },
      {
        name: 'AutomationCreate',
        path: 'automations/add/:type',
        meta: { product: 'automations' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/automations/AutomationCreate.vue')
      },
      {
        name: 'AutomationEdit',
        path: 'automations/:id',
        meta: { product: 'automations' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/automations/AutomationEdit.vue')
      },
      {
        name: 'ContactList',
        path: 'contacts',
        meta: { product: 'automations' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/contacts/ContactList.vue')
      },
      {
        name: 'ContactCreate',
        path: 'contacts/add',
        meta: { product: 'automations' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/contacts/ContactCreate.vue')
      },
      {
        name: 'ContactEdit',
        path: 'contacts/:id',
        meta: { product: 'automations' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/contacts/ContactEdit.vue')
      },
      {
        name: 'LogList',
        path: 'logs',
        meta: { product: 'automations' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/logs/LogList.vue')
      },


      // ========================
      // RECORDS
      // ========================

      {
        name: 'RecordList',
        path: 'records',
        meta: { product: 'records' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/records/RecordList.vue')
      },
      {
        name: 'RecordCreate',
        path: 'records/add',
        meta: { product: 'records' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/records/RecordCreate.vue')
      },
      {
        name: 'RecordEdit',
        path: 'records/:id',
        meta: { product: 'records' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/records/RecordEdit.vue')
      },
      {
        name: 'CategoryList',
        path: 'categories',
        meta: { product: 'records' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/categories/CategoryList.vue')
      },
      {
        name: 'FileList',
        path: 'files',
        meta: { product: 'records' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/files/FileList.vue')
      },
      {
        name: 'VendorList',
        path: 'vendors',
        meta: { product: 'records' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/vendors/VendorList.vue')
      },


      // ========================
      // ASSETS
      // ========================
      {
        name: 'AreaList',
        path: 'areas',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/areas/AreaList.vue')
      },
      {
        name: 'DepotList',
        path: 'depots',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/depots/DepotList.vue')
      },
      {
        name: 'DepotCreate',
        path: 'depots/add',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/depots/DepotForm.vue')
      },
      {
        name: 'DepotEdit',
        path: 'depots/:id',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/depots/DepotForm.vue')
      },
      {
        name: 'DriverList',
        path: 'drivers',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/drivers/DriverList.vue')
      },
      {
        name: 'DriverGroups',
        path: 'driver-groups',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/drivers/DriverGroups.vue')
      },
      {
        name: 'VehicleList',
        path: 'vehicles',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/vehicles/VehicleList.vue')
      },
      {
        name: 'VehicleGroups',
        path: 'vehicle-groups',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/vehicles/VehicleGroups.vue')
      },


      // ========================
      // ROUTES
      // ========================

      {
        name: 'RouteList',
        path: 'routes',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/routes/RouteList.vue')
      },
      {
        name: 'RouteView',
        path: 'routes/:id',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/routes/RouteView.vue')
      },


      // ========================
      // REPORTS
      // ========================

      {
        name: 'ReportList',
        path: 'reports',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/reports/ReportList.vue')
      },
      {
        name: 'ReportEdit',
        path: 'reports/:id',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/reports/ReportView.vue')
      },
      {
        name: 'ReportView',
        path: 'reports/add/:type',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/reports/ReportView.vue')
      },


      // ========================
      // SETTINGS
      // ========================

      {
        name: 'Settings',
        path: 'settings',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsView.vue'),
        redirect: { name: 'SettingsCompany' },
        children: [
          {
            name: 'SettingsCompany',
            path: 'company',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsCompany.vue'),
          },
          {
            name: 'SettingsSecurity',
            path: 'security',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsSecurity.vue'),
          },
          {
            name: 'SettingsIntegrations',
            path: 'integrations',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsIntegrations.vue'),
          },
          {
            name: 'SettingsBilling',
            path: 'billing',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsBilling.vue'),
          },
          {
            name: 'SettingsSubscription',
            path: 'subscription',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsSubscription.vue'),
          },
          {
            name: 'SettingsTaxes',
            path: 'taxes',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsTaxes.vue'),
          },
          {
            name: 'SettingsUsers',
            path: 'users',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/settings/SettingsUsers.vue'),
          }
        ]
      },
    ]
  }
]
